import { getSourceEventParams, useAmplitude } from '@crehana/analytics';
import { date } from '@crehana/utils';
import { useRouter } from 'next/router';

import useAdminDashboard from '@/views/AdminDashboard/hooks/useAdminDashboard';
import useDashboardMetrics from '@/views/AdminDashboard/hooks/useDashboardMetrics';

import type { GenerateAdministrationReportVariables } from '../useSendAdminReport/graphql/types/GenerateAdministrationReport';
import type { GenerateCoursesReportVariables } from '../useSendCoursesReport/graphql/types/GenerateCoursesReport';
import type { SendOrganizationReportVariables } from '../useSendGeneralReport/graphql/types/SendOrganizationReport';
import type { ReportDownloadTracksVariables } from '../useSendTracksReport/graphql/types/ReportDownloadTracks';

const useReportsAmplitude = (slug: string) => {
  const {
    currentUserOrganization,
    organizationId,
    isCorporation,
    hasStudioAvailable,
  } = useAdminDashboard();
  const { activityOrganization } = useDashboardMetrics({ slug });
  const router = useRouter();
  const { logEvent } = useAmplitude();

  const logSubmit = ({
    event,
    reportType,
    filters,
    status,
  }: {
    event: string;
    reportType: string;
    filters:
      | SendOrganizationReportVariables
      | ReportDownloadTracksVariables
      | GenerateAdministrationReportVariables
      | GenerateCoursesReportVariables;
    status: string;
  }) => {
    logEvent({
      event,
      data: {
        ...getSourceEventParams(),
        'Month Date': date.getMonthName(),
        'Day of the week': date.format(new Date(), 'dddd'),
        'Report Type': reportType,
        'Report Filters': filters,
        'Organization Session': router.asPath.split('/')[2],
        user: {
          'Current User ORG': currentUserOrganization,
          'Organization Type': isCorporation,
          'Organization Id': organizationId,
          'Organization Slug': slug,
          'Start Date': activityOrganization?.activityPrevious[0]?.date,
          'Has Classroom': hasStudioAvailable,
        },
        status,
      },
    });
  };

  return {
    logEvent,
    logSubmit,
  };
};

export default useReportsAmplitude;
